<template>
  <div class="app-connectors">
    <b-card>
      <b-row class="mb-3">
        <b-col md="6">
          <b-input-group>
            <b-form-input
              v-model="searchQuery"
              :placeholder="$translate('search')"
              @keyup.enter="fetchData"
            />
            <b-input-group-append>
              <b-button variant="primary" @click="fetchData">
                <i class="fa fa-search" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col md="6" class="text-right">
          <b-button variant="primary" @click="$router.push({ name: 'appConnectorCreate' })">
            <i class="fa fa-plus mr-1" />
            {{ $translate('new_connector') }}
          </b-button>
        </b-col>
      </b-row>

      <b-table
        :items="connectors"
        :fields="fields"
        :busy="loading"
        responsive
        hover
        show-empty
        @row-clicked="viewConnector"
      >
        <template #cell(name)="{ item }">
          <div>
            <strong>{{ item.name }}</strong>
            <br />
            <small class="text-muted">{{ item.description }}</small>
          </div>
        </template>

        <template #cell(template)="{ item }">
          <b-badge variant="info">{{ item.template_slug || item.connection_mode }}</b-badge>
        </template>

        <template #cell(is_active)="{ item }">
          <b-form-checkbox
            v-model="item.is_active"
            switch
            @change="toggleStatus(item)"
          />
        </template>

        <template #cell(created_at)="{ item }">
          {{ item.created_at | formatDate }}
        </template>

        <template #cell(actions)="{ item }">
          <b-button size="sm" variant="outline-primary" @click.stop="viewConnector(item)">
            <i class="fa fa-eye" />
          </b-button>
          <b-button size="sm" variant="outline-danger" class="ml-1" @click.stop="confirmDelete(item)">
            <i class="fa fa-trash" />
          </b-button>
        </template>

        <template #table-busy>
          <div class="text-center my-3">
            <b-spinner variant="primary" />
          </div>
        </template>
      </b-table>

      <b-pagination
        v-if="pagination"
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.pageSize"
        align="center"
        @input="onPageChange"
      />
    </b-card>

    <b-modal
      v-model="deleteModalVisible"
      :title="$translate('confirm_delete')"
      @ok="deleteConnector"
    >
      <p>{{ $translate('are_you_sure_delete') }} <strong>{{ selectedConnector ? selectedConnector.name : '' }}</strong>?</p>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: '',
      loading: false,
      currentPage: 1,
      deleteModalVisible: false,
      selectedConnector: null,
      fields: [
        { key: 'name', label: this.$translate('name'), sortable: true },
        { key: 'template', label: this.$translate('template') },
        { key: 'is_active', label: this.$translate('status') },
        { key: 'created_at', label: this.$translate('created_at'), sortable: true },
        { key: 'actions', label: this.$translate('actions'), class: 'text-right' },
      ],
    }
  },
  computed: {
    connectors() {
      return this.$store.state.appConnector.items
    },
    pagination() {
      return this.$store.state.appConnector.pagination
    },
  },
  async mounted() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        await this.$store.dispatch('appConnector/fetch', {
          query: this.searchQuery,
          page: this.currentPage,
        })
      } finally {
        this.loading = false
      }
    },
    onPageChange(page) {
      this.currentPage = page
      this.fetchData()
    },
    viewConnector(item) {
      this.$router.push({ name: 'appConnectorDetail', params: { id: item.id } })
    },
    async toggleStatus(item) {
      await this.$store.dispatch('appConnector/toggleStatus', item.id)
    },
    confirmDelete(item) {
      this.selectedConnector = item
      this.deleteModalVisible = true
    },
    async deleteConnector() {
      if (this.selectedConnector) {
        await this.$store.dispatch('appConnector/delete', this.selectedConnector.id)
        this.deleteModalVisible = false
        this.selectedConnector = null
      }
    },
  },
  filters: {
    formatDate(val) {
      if (!val) return ''
      return new Date(val).toLocaleDateString()
    },
  },
}
</script>
